"use client";

import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
import { useState, useRef, useEffect } from "react";
import { formatDistanceToNow } from "date-fns";
import { transcribeAudio, summarizeMeeting } from "./actions";
import { Progress } from "./ui/progress";
import { Button } from "./ui/button";
import { ScrollArea } from "./ui/scroll-area";
import { useToast } from "../hooks/use-toast";

// Define the correct toast interface to fix TypeScript errors

import AwesomeIcon from "../../AwesomeIcon";
import useCreateMeeting from "../hooks/useCreateMeeting";
import { faMicrophone, faHistory, faClock, faExclamationCircle } from "@fortawesome/pro-light-svg-icons";
import { faPlay, faPause, faStop } from "@fortawesome/pro-solid-svg-icons";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import Tooltip from "../../common/Tooltip";
export function Recorder(_ref) {
  var meetings = _ref.meetings,
    refetchMeetings = _ref.refetchMeetings,
    isLoadingHistory = _ref.isLoadingHistory,
    historyError = _ref.historyError,
    setSelectedMeeting = _ref.setSelectedMeeting,
    typeOfSummary = _ref.typeOfSummary,
    isRecording = _ref.isRecording,
    setIsRecording = _ref.setIsRecording;
  var _useState = useState(false),
    isPaused = _useState[0],
    setIsPaused = _useState[1];
  var _useState2 = useState(0),
    recordingTime = _useState2[0],
    setRecordingTime = _useState2[1];
  var _useState3 = useState(null),
    audioBlob = _useState3[0],
    setAudioBlob = _useState3[1];
  var _useState4 = useState(false),
    isProcessing = _useState4[0],
    setIsProcessing = _useState4[1];
  var _useState5 = useState(0),
    processingProgress = _useState5[0],
    setProcessingProgress = _useState5[1];
  var _useState6 = useState(null),
    processingError = _useState6[0],
    setProcessingError = _useState6[1];
  var MAX_RECORDING_HRS = 2;
  var createMeetingMutation = useCreateMeeting();
  var mediaRecorderRef = useRef(null);
  var chunksRef = useRef([]);
  var timerRef = useRef(null);
  var processingTimerRef = useRef(null);
  var recordingTimeRef = useRef(0);
  var _useToast = useToast(),
    toast = _useToast.toast;

  // Helper function to safely call toast with proper typing
  var showToast = function showToast(params) {
    var toastFunc = toast;
    toastFunc(params);
  };

  // Cleanup timers
  useEffect(function () {
    return function () {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      if (processingTimerRef.current) {
        clearInterval(processingTimerRef.current);
      }
    };
  }, []);
  useEffect(function () {
    if (recordingTime > MAX_RECORDING_HRS * 60 * 60) {
      stopRecording();
    }
  }, [recordingTime]);
  var startRecording = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var stream, mediaRecorder, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.p = 0;
            // Reset any existing state
            setAudioBlob(null);
            setProcessingError(null);
            _context.n = 1;
            return navigator.mediaDevices.getUserMedia({
              audio: true
            });
          case 1:
            stream = _context.v;
            mediaRecorder = new MediaRecorder(stream);
            mediaRecorderRef.current = mediaRecorder;
            chunksRef.current = [];
            mediaRecorder.ondataavailable = function (e) {
              chunksRef.current.push(e.data);
            };
            mediaRecorder.onstop = function () {
              var audioBlob = new Blob(chunksRef.current, {
                type: "audio/webm"
              });
              setAudioBlob(audioBlob);

              // Stop all tracks to release the microphone
              stream.getTracks().forEach(function (track) {
                return track.stop();
              });

              // Pass the current recording time to processMeeting
              processMeeting(audioBlob, recordingTimeRef.current);
            };
            mediaRecorder.start(1000);
            setIsRecording(true);
            setIsPaused(false);
            setRecordingTime(0);
            recordingTimeRef.current = 0;
            timerRef.current = setInterval(function () {
              setRecordingTime(function (prevTime) {
                var newTime = prevTime + 1;
                recordingTimeRef.current = newTime;
                return newTime;
              });
            }, 1000);
            showToast({
              title: "Recording started",
              description: "Your meeting is now being recorded"
            });
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.error("Error starting recording:", _t);
            toast({
              title: "Recording failed",
              description: "Could not access microphone",
              variant: "destructive"
            });
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function startRecording() {
      return _ref2.apply(this, arguments);
    };
  }();
  var pauseRecording = function pauseRecording() {
    if (mediaRecorderRef.current && isRecording && !isPaused) {
      mediaRecorderRef.current.pause();
      setIsPaused(true);
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      toast({
        title: "Recording paused",
        description: "Your recording has been paused"
      });
    }
  };
  var resumeRecording = function resumeRecording() {
    if (mediaRecorderRef.current && isRecording && isPaused) {
      mediaRecorderRef.current.resume();
      setIsPaused(false);
      timerRef.current = setInterval(function () {
        setRecordingTime(function (prevTime) {
          var newTime = prevTime + 1;
          recordingTimeRef.current = newTime;
          return newTime;
        });
      }, 1000);
      toast({
        title: "Recording resumed",
        description: "Your recording has been resumed"
      });
    }
  };
  var stopRecording = function stopRecording() {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      setIsPaused(false);
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      toast({
        title: "Recording stopped",
        description: "Your recording has been saved"
      });
    }
  };
  var formatTime = function formatTime(seconds) {
    var minutes = Math.floor(seconds / 60);
    var remainingSeconds = seconds % 60;
    return "".concat(minutes.toString().padStart(2, "0"), ":").concat(remainingSeconds.toString().padStart(2, "0"));
  };
  var loadMeeting = function loadMeeting(meeting, index) {
    setSelectedMeeting(meeting);
  };
  var processMeeting = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_audioBlob, _recordingTime) {
      var audioBlob, currentRecordingTime, formData, transcription, summary, _summary$topics, _summary$action_items, meetingName, payloadData, audioArrayBuffer, audioFile, _formData, _t2, _t3, _t4;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            audioBlob = _audioBlob;
            if (audioBlob) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            currentRecordingTime = _recordingTime || recordingTime;
            _context3.p = 2;
            // Reset any previous errors
            setProcessingError(null);
            setIsProcessing(true);
            setProcessingProgress(0);

            // Simulate progress for better UX
            processingTimerRef.current = setInterval(function () {
              setProcessingProgress(function (prev) {
                if (prev >= 95) {
                  return prev;
                }
                return prev + 5;
              });
            }, 500);
            toast({
              title: "Processing started",
              description: "Transcribing and summarizing your meeting..."
            });

            // Create a FormData object to send the audio file
            formData = new FormData();
            formData.append("audio", audioBlob, "recording.webm");
            _context3.p = 3;
            _context3.n = 4;
            return transcribeAudio(formData);
          case 4:
            transcription = _context3.v;
            if (transcription) {
              _context3.n = 5;
              break;
            }
            throw new Error("Transcription failed: No text was returned");
          case 5:
            setProcessingProgress(70);

            // Then summarize the transcription using our API route
            _context3.n = 6;
            return summarizeMeeting(transcription.conversation || [], typeOfSummary);
          case 6:
            summary = _context3.v;
            if (summary) {
              _context3.n = 7;
              break;
            }
            throw new Error("Summarization failed: No summary was returned");
          case 7:
            setProcessingProgress(100);

            // Create meeting using API
            _context3.p = 8;
            meetingName = summary.title || "Meeting (".concat(new Date().toLocaleDateString(), ")");
            payloadData = {
              summary: {
                title: meetingName,
                date: new Date().toISOString(),
                duration: "".concat(Math.floor(currentRecordingTime / 60), "m ").concat(currentRecordingTime % 60, "s"),
                topics_count: ((_summary$topics = summary.topics) === null || _summary$topics === void 0 ? void 0 : _summary$topics.length) || 0,
                action_items_count: ((_summary$action_items = summary.action_items) === null || _summary$action_items === void 0 ? void 0 : _summary$action_items.length) || 0
              },
              details: {
                transcription: transcription.conversation,
                meeting_summary: {
                  overview: summary.overview || "",
                  topics: summary.topics || [],
                  action_items: summary.action_items || []
                }
              }
            }; // Convert audio blob to array buffer
            _context3.n = 9;
            return audioBlob.arrayBuffer();
          case 9:
            audioArrayBuffer = _context3.v;
            // Create file with array buffer
            audioFile = new File([audioArrayBuffer], "".concat(meetingName, ".mp3"), {
              type: "audio/mpeg"
            }); // Create FormData for file upload
            _formData = new FormData();
            _formData.append("audio_file", audioFile);
            _formData.append("data", JSON.stringify(payloadData));

            // Create meeting via API
            createMeetingMutation.mutate(_formData, {
              onSuccess: function () {
                var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(newMeeting) {
                  var response, newlyAddedMeeting;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        _context2.n = 1;
                        return refetchMeetings();
                      case 1:
                        response = _context2.v;
                        newlyAddedMeeting = response.data.find(function (_meeting) {
                          return _meeting.id === newMeeting.id;
                        });
                        if (newlyAddedMeeting) {
                          setSelectedMeeting(newlyAddedMeeting);
                        }
                        setRecordingTime(0);
                        recordingTimeRef.current = 0;
                        toast({
                          title: "Meeting saved",
                          description: "Your meeting has been summarized and saved"
                        });
                      case 2:
                        return _context2.a(2);
                    }
                  }, _callee2);
                }));
                function onSuccess(_x3) {
                  return _onSuccess.apply(this, arguments);
                }
                return onSuccess;
              }(),
              onError: function onError(error) {
                console.error("Error saving meeting:", error);
                toast({
                  title: "Error",
                  description: "Failed to save the meeting",
                  variant: "destructive"
                });
              }
            });
            _context3.n = 11;
            break;
          case 10:
            _context3.p = 10;
            _t2 = _context3.v;
            console.error("Error creating meeting payload:", _t2);
            toast({
              title: "Error",
              description: "Failed to prepare meeting data",
              variant: "destructive"
            });
          case 11:
            // Scroll to summary section with a slight delay to ensure it's rendered
            setTimeout(function () {
              var summarySection = document.getElementById("summary-section");
              if (summarySection) {
                var _document$querySelect;
                // Calculate header height to account for fixed header
                var headerHeight = ((_document$querySelect = document.querySelector("header")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getBoundingClientRect().height) || 0;

                // Calculate position to scroll to (element's top position minus header height and some additional padding)
                var yOffset = -(headerHeight + 20); // header height plus 20px padding
                var y = summarySection.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({
                  top: y,
                  behavior: "smooth"
                });
              }
            }, 500);
            _context3.n = 13;
            break;
          case 12:
            _context3.p = 12;
            _t3 = _context3.v;
            console.error("API Error:", _t3);
            setProcessingError(_t3.message || "Failed to process the meeting");
          case 13:
            _context3.n = 15;
            break;
          case 14:
            _context3.p = 14;
            _t4 = _context3.v;
            console.error("Error processing meeting:", _t4);
            setProcessingError(_t4.message || "Could not process your meeting");
          case 15:
            _context3.p = 15;
            if (processingTimerRef.current) {
              clearInterval(processingTimerRef.current);
            }
            setIsProcessing(false);
            return _context3.f(15);
          case 16:
            return _context3.a(2);
        }
      }, _callee3, null, [[8, 10], [3, 12], [2, 14, 15, 16]]);
    }));
    return function processMeeting(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    id: "recorder-container",
    className: "flex flex-col transition-all duration-300 opacity-100 h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-6 h-full flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 p-6 flex flex-col sm:justify-center w-full h-auto rounded-lg"
  }, isRecording && !isPaused && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 pointer-events-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "recording-wave wave1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "recording-wave wave2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "recording-wave wave3"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex h-full items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full w-full items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-2xl font-bold text-gray-900 dark:text-white mb-2"
  }, "Record Your Meeting"), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-600 dark:text-gray-400"
  }, "Capture your conversations and get instant summaries"))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full w-full items-center justify-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-md flex items-center justify-center"
  }, isRecording ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-3 w-3 rounded-full ".concat(isPaused ? "bg-amber-500" : "bg-red-500 animate-pulse-recording"),
    style: {
      boxShadow: isPaused ? "none" : "0 0 0 0 rgba(239, 68, 68, 0.4)"
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "font-medium text-gray-700 dark:text-gray-300"
  }, isPaused ? "Recording paused" : "Recording in progress"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Tooltip, {
    tooltipText: "Max ".concat(MAX_RECORDING_HRS, " hours recording time"),
    verticalPosition: "bottom",
    position: "left",
    tooltipStyles: "p-3 rounded-lg"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faInfoCircle,
    size: "1x",
    className: "text-gray-700 dark:text-gray-300"
  })))) : null), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, isProcessing ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3 mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "animate-spin h-5 w-5 border-2 border-teal-300 border-t-teal-600 rounded-full"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-md font-medium text-gray-700 dark:text-gray-300"
  }, "Processing your meeting...")) : /*#__PURE__*/React.createElement("div", {
    className: "text-3xl md:text-2xl font-mono text-gray-900 dark:text-white mb-2 tracking-wider"
  }, formatTime(recordingTime))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center gap-4 w-full"
  }, isProcessing ? /*#__PURE__*/React.createElement("div", {
    className: "w-full max-w-md mt-6 space-y-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 rounded-lg backdrop-blur-sm"
  }, /*#__PURE__*/React.createElement(Progress, {
    value: processingProgress,
    className: "!h-2 bg-gray-200 dark:bg-gray-700 mb-2",
    indicatorClassName: "bg-teal-600"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-gray-600 dark:text-gray-400 text-center"
  }, processingProgress < 50 ? "🎙️ Transcribing audio..." : processingProgress < 95 ? "🤖 Generating summary..." : "✨ Finalizing..."))) : !isRecording ? /*#__PURE__*/React.createElement(Button, {
    onClick: startRecording,
    size: "lg",
    className: "bg-teal-600 hover:bg-teal-500 border-teal-500 text-white px-8 py-4 text-lg font-semibold shadow-lg relative overflow-hidden group border transition-colors"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-12 w-12 rounded-full bg-teal-500/20 animate-ping"
  })), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faMicrophone,
    size: "lg",
    className: "mr-3 relative z-10"
  }), /*#__PURE__*/React.createElement("span", {
    className: "relative z-10"
  }, "Start Recording")) : /*#__PURE__*/React.createElement(React.Fragment, null, isPaused ? /*#__PURE__*/React.createElement(Button, {
    onClick: resumeRecording,
    className: "bg-gray-700 hover:bg-gray-600 hover:border-gray-400 text-white font-semibold shadow-md border border-gray-600 transition-colors text-lg"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faPlay,
    size: "lg",
    className: "py-3 px-8"
  })) : /*#__PURE__*/React.createElement(Button, {
    onClick: pauseRecording,
    className: "bg-amber-600 hover:bg-amber-500 hover:border-amber-400 text-white font-semibold shadow-md border border-amber-700 transition-colors text-lg"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faPause,
    size: "lg",
    className: "py-3 px-8"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: stopRecording,
    className: "bg-red-600 hover:bg-red-500 hover:border-red-400 text-white font-semibold shadow-md border border-red-700 transition-colors text-lg"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faStop,
    size: "lg",
    className: "py-3 px-8"
  })))), processingError && /*#__PURE__*/React.createElement("div", {
    className: "w-full max-w-md mt-3 p-4 rounded-lg text-md"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 mb-2"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faExclamationCircle,
    size: "sm",
    className: "text-red-500"
  }), /*#__PURE__*/React.createElement("p", {
    className: " font-medium text-red-700 dark:text-red-300"
  }, "Processing Error : ", processingError), /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer underline",
    onClick: function onClick() {
      if (audioBlob) {
        processMeeting(audioBlob, recordingTimeRef.current);
      }
    }
  }, "Retry")))))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full w-full overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-base font-semibold text-gray-900 dark:text-white flex items-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faHistory,
    size: "sm",
    className: "mr-4"
  }), "Previous Recordings ", "(".concat(meetings.length, ")"))), /*#__PURE__*/React.createElement(ScrollArea, {
    className: "flex h-full"
  }, isLoadingHistory ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center h-40 text-center p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "animate-spin h-6 w-6 border-2 border-gray-300 dark:border-gray-600 border-t-gray-600 dark:border-t-gray-300 rounded-full mb-2"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-sm text-gray-600 dark:text-gray-400"
  }, "Loading recordings...")) : historyError ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center h-40 text-center p-4"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faExclamationCircle,
    size: "lg",
    className: "text-red-500 mb-2"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-sm text-gray-600 dark:text-gray-400"
  }, historyError)) : meetings.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center text-center p-4 h-full"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faClock,
    size: "lg",
    className: "text-gray-400 dark:text-gray-500 mb-3"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-600 dark:text-gray-400 mb-2 text-lg"
  }, "No recordings yet"), /*#__PURE__*/React.createElement("p", {
    className: "text-md text-gray-500 dark:text-gray-500 mb-4"
  }, "Record a meeting to see it here"), /*#__PURE__*/React.createElement("div", {
    className: "text-md text-left p-4 bg-gray-50 dark:bg-gray-800 rounded-lg text-gray-600 dark:text-gray-400"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-medium mb-2"
  }, "How to save recordings:"), /*#__PURE__*/React.createElement("ol", {
    className: "list-decimal pl-4 space-y-1"
  }, /*#__PURE__*/React.createElement("li", null, "Record your meeting"), /*#__PURE__*/React.createElement("li", null, "Click \"Summarize Meeting\""), /*#__PURE__*/React.createElement("li", null, "Wait for processing to complete")))) : /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 py-4"
  }, meetings.sort(function (a, b) {
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  }).map(function (meeting, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: meeting.id,
      className: "group relative bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-5 hover:shadow-lg hover:border-teal-300 dark:hover:border-teal-600 cursor-pointer transition-all duration-300 transform hover:-translate-y-1",
      onClick: function onClick() {
        return loadMeeting(meeting, index);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-start mb-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center space-x-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-1"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "font-semibold text-base text-gray-900 dark:text-white line-clamp-2 leading-tight"
    }, meeting.summary.title || "Meeting"), /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-gray-500 dark:text-gray-400 mt-1"
    }, formatDistanceToNow(new Date(meeting.created_at), {
      addSuffix: true
    }))))), /*#__PURE__*/React.createElement("div", {
      className: "space-y-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center space-x-2"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faClock,
      size: "sm",
      className: "text-gray-400"
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-sm font-medium text-gray-700 dark:text-gray-300"
    }, meeting.summary.duration)), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center space-x-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center space-x-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-2 h-2 bg-blue-500 rounded-full"
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-sm text-gray-600 dark:text-gray-400"
    }, meeting.summary.topics_count, " topics")), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center space-x-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-2 h-2 bg-green-500 rounded-full"
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-sm text-gray-600 dark:text-gray-400"
    }, meeting.summary.action_items_count, " actions")))));
  })))))));
}